/* ============================================================
   data.ts — данные для ArticlesSection (страница /blog)
   Статьи и список категорий для фильтрации
   ============================================================ */

import type { Article } from "./types.ts";

/** Все статьи блога */
export const BLOG_ARTICLES: Article[] = [
    {
        id: "1",
        category: "УК",
        title: "Как автоматизация заявок снижает нагрузку на диспетчеров в 3 раза",
        excerpt:
            "Разбираем кейс реальной управляющей компании, которая перешла на цифровую платформу и сократила время обработки заявок с 2 часов до 20 минут.",
        date: "12 мая 2026",
        readTime: "7 мин",
        imageGradient: "linear-gradient(135deg, #1f7a5a, #2ecc71)",
    },
    {
        id: "2",
        category: "Жители",
        title: "5 способов сэкономить на ЖКУ с помощью цифровых инструментов",
        excerpt:
            "Онлайн-оплата без комиссии, своевременная передача показаний и автоплатёж — рассказываем, как жители экономят до 15% ежемесячно.",
        date: "8 мая 2026",
        readTime: "5 мин",
        imageGradient: "linear-gradient(135deg, #3b82f6, #60a5fa)",
    },
    {
        id: "3",
        category: "Аналитика",
        title: "Цифровизация ЖКХ в 2026: тренды и прогнозы рынка",
        excerpt:
            "Обзор ключевых трендов: рост онлайн-оплат, внедрение IoT в многоквартирных домах и развитие мобильных приложений для УК.",
        date: "3 мая 2026",
        readTime: "10 мин",
        imageGradient: "linear-gradient(135deg, #8b5cf6, #a78bfa)",
    },
    {
        id: "4",
        category: "УК",
        title: "Чек-лист: как выбрать программное обеспечение для управляющей компании",
        excerpt:
            "На что обращать внимание при выборе ПО? Интеграции, мобильное приложение, поддержка — собрали 12 критериев оценки.",
        date: "28 апреля 2026",
        readTime: "6 мин",
        imageGradient: "linear-gradient(135deg, #f59e0b, #fbbf24)",
    },
    {
        id: "5",
        category: "Жители",
        title: "Голосования в ЖК: как принимать коллективные решения без собраний",
        excerpt:
            "Новый инструмент платформы my:home позволяет жителям голосовать за важные решения прямо из приложения — без сбора подписей.",
        date: "22 апреля 2026",
        readTime: "4 мин",
        imageGradient: "linear-gradient(135deg, #10b981, #34d399)",
    },
    {
        id: "6",
        category: "Аналитика",
        title: "ROI от внедрения цифровой платформы: считаем вместе",
        excerpt:
            "Сколько часов и денег реально экономит управляющая компания при переходе на цифровые инструменты? Реальные расчёты.",
        date: "15 апреля 2026",
        readTime: "8 мин",
        imageGradient: "linear-gradient(135deg, #ef4444, #f87171)",
    },
];

/** Список категорий для фильтрации — "Все" всегда первый */
export const BLOG_CATEGORIES: string[] = ["Все", "УК", "Жители", "Аналитика"];
